import { useState, useEffect } from 'react';
import { CImage } from '@coreui/react';
import { getFile } from 'features/dinamic';
import imgNotFound from '../../resources/notFound.png';

interface DiplomadoImageProps {
  basepath?: string;
  fileImage?: string;
  alt: string;
  className?: string;
  style?: React.CSSProperties;
}

const DiplomadoImage = ({ basepath, fileImage, alt, className, style }: DiplomadoImageProps) => {
  const [imageSrc, setImageSrc] = useState<string>(imgNotFound);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    let blobUrl: string | null = null;

    const loadImage = async () => {
      if (!basepath || !fileImage) {
        setImageSrc(imgNotFound);
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);
        const fileUrl = `${basepath}${fileImage}`;
        const response = await getFile({ fileUrl, fileName: fileImage });

        if (response && response.blob) {
          blobUrl = URL.createObjectURL(response.blob);
          setImageSrc(blobUrl);
        } else {
          setImageSrc(imgNotFound);
        }
      } catch (error) {
        setImageSrc(imgNotFound);
      } finally {
        setIsLoading(false);
      }
    };

    loadImage();

    return () => {
      if (blobUrl) {
        URL.revokeObjectURL(blobUrl);
      }
    };
  }, [basepath, fileImage]);

  return (
    <CImage
      src={imageSrc}
      alt={alt}
      className={className}
      style={{
        ...style,
        opacity: isLoading ? 0.5 : 1,
        transition: 'opacity 0.3s ease'
      }}
      onError={({ currentTarget }: any) => {
        currentTarget.onerror = null;
        currentTarget.src = imgNotFound;
      }}
    />
  );
};

export default DiplomadoImage;
